export const OPT_OUT_LS_KEY = "opt-out-web-authn";
export const CUSTOMER_ID = "customerId";
export const DEVICE_ID = "deviceId";
export const LOGIN_AFTER_WEB_AUTH_REGISTRATION_FORM_ID = "login-web-authn-form";
